import { Box } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";

const ClaimHomepage = () => {
	return (
		<Box>
			<Outlet />
		</Box>
	);
};

export default ClaimHomepage;
